import React from 'react';
import { FormRenderData, GetLocale, Module } from '@cuatroochenta/co-admin-react-library';
import ImportUsersScreen from "./actions/modules/importUsers/ImportUsersScreen";
import NewsScreen from "./actions/modules/news/NewsScreen";
import './I18n/i18n';
import MessagingScreen from "./actions/modules/messaging/messagingScreen/MessagingScreen";

import '@cuatroochenta/co-admin-react-library/lib/index.css';
import './res/scss/custom-styles.scss'
import MenuScreen from './actions/modules/menu/MenuScreen';
import SyncUsersScreen from './actions/modules/synchronizeUsers/SyncUsersScreen';
import AlbumsScreen from './actions/modules/albums/AlbumsScreen';
import CalendarScreen from './actions/modules/calendar/CalendarScreen';
import DocumentsScreen from './actions/modules/documents/DocumentsScreen';
import StatisticsScreen from './actions/modules/statistics/StatisticsScreen';
import SyncDocumentsScreen from './actions/modules/synchronizeDocuments/SyncUsersScreen';
import AuditScreen from './actions/modules/audit/AuditScreen';

interface Filters {
    [dynamic: string]: string
}

class App extends React.Component {

    private beforeFormView = (entity: string, type: string, data: FormRenderData): React.ReactNode => {
        return null;
    };

    private afterFormView = (entity: string, type: string, data: FormRenderData): React.ReactNode => {
        return null;
    };

    private customButtonsList = (entity: string, filters: Filters, orderby: string, order: string): React.ReactNode => {
        return null;
    };

    private afterLoginButton = (): React.ReactNode => {
        return null;
    };

    public render() {
        const languages = [
            {name: 'Español', code: 'es'},
            {name: 'English', code: 'en'},
            {name: 'Italiano', code: 'it'},
        ]

        return (
            <Module
                actions={[
                    {name: 'importUsers', element: <ImportUsersScreen/>},
                    {name: 'news', element: <NewsScreen />},
                    {name: 'menu', element: <MenuScreen />},
                    {name: 'messaging', element: <MessagingScreen />},
                    {name: 'synchronizeUsers', element: <SyncUsersScreen />},
                    {name: 'synchronizeDocuments', element: <SyncDocumentsScreen />},
                    {name: 'albums', element: <AlbumsScreen />},
                    {name: 'calendar', element: <CalendarScreen />},
                    {name: 'socialDocuments', element: <DocumentsScreen />},
                    {name: 'statistics', element: <StatisticsScreen />},
                    {name: 'audit', element: <AuditScreen />}
                ]}
                beforeFormView={this.beforeFormView}
                afterFormView={this.afterFormView}
                customButtonsList={this.customButtonsList}
                locale={GetLocale()}
                afterLoginButton={this.afterLoginButton}
                languages={languages}
            />
        );
    }

}

export default App;
